import React from "react"
import { useTranslation } from "react-i18next"
import ApiConnectorCard from "../ApiConnectorCard"
import azureLogo from "assets/images/connectors/azure-logo.svg"

/**
 * Azure card for the developer portal
 * Redirects to Azure documentation for configuration
 */
const AzureCard = () => {
  const { t } = useTranslation()

  return (
    <ApiConnectorCard
      serviceName={t("developer_portal:connectors.azure.name")}
      description={t("developer_portal:connectors.azure.description")}
      tag={t("developer_portal:connectors.azure.tag")}
      documentationUrl={t("developer_portal:connectors.azure.documentation_url")}
      logoSource={azureLogo}
      logoAlt="Azure"
    />
  )
}

export default AzureCard
